import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    messageGroupListLoading: false,
    messageGroupListSuccess: null,
    messageGroupListError: '',
    messageGroupLoading: false,
    messageGroupSuccess: {},
    messageGroupError: '',
    messageListLoading: false,
    messageListSuccess: null,
    messageListError: '',
    messageReadListLoading: false,
    messageReadListSuccess: null,
    messageReadListError: '',
    getMessageDataLoading: false,
    getMessageDataSuccess: {},
    getMessageDataError: '',
    videoListLoading: false,
    videoListSuccess: null,
    videoListError: '',
    getVideoDataLoading: false,
    getVideoDataSuccess: {},
    getVideoDataError: '',
    youTubeVideoListLoading: false,
    youTubeVideoListSuccess: null,
    youTubeVideoListError: '',
    getYouTubeVideoDataLoading: false,
    getYouTubeVideoDataSuccess: {},
    getYouTubeVideoDataError: '',
    getCounsellingListDataLoading: false,
    getCounsellingListDataSuccess: {},
    getCounsellingListDataError: '',
    getCounsellingSlotListLoading: false,
    getCounsellingSlotListSuccess: {},
    getCounsellingSlotDataLoading: false,
    getCounsellingSlotDataSuccess: {}
}

export const messagesSlice = createSlice({
    name: 'messages',
    initialState,
    reducers: {
        setMessageGroupListLoading: (state, action) => {
            state.messageGroupListLoading = true;
            state.messageGroupListSuccess = null;
            state.messageGroupListError = '';
        },
        setMessageGroupListSuccess: (state, action) => {
            state.messageGroupListLoading = false;
            state.messageGroupListSuccess = action.payload;
            state.messageGroupListError = '';
        },
        setMessageGroupListError: (state, action) => {
            state.messageGroupListLoading = false;
            state.messageGroupListSuccess = null;
            state.messageGroupListError = action.payload;
        },
        getMessageGroupLoading: (state) => {
            state.messageGroupLoading = true;
            state.messageGroupSuccess = {};
            state.messageGroupError = '';
        },
        getMessageGroupSuccess: (state, action) => {
            state.messageGroupLoading = false;
            state.messageGroupSuccess = action.payload;
            state.messageGroupError = '';
        },
        getMessageGroupError: (state, action) => {
            state.messageGroupLoading = false;
            state.messageGroupSuccess = {};
            state.messageGroupError = action.payload;
        },
        resetMessageGroupDetails: (state, action) => {
            state.messageGroupSuccess = {};
        },
        setMessageListLoading: (state, action) => {
            state.messageListLoading = true;
            state.messageListSuccess = null;
            state.messageListError = '';
        },
        setMessageListSuccess: (state, action) => {
            state.messageListLoading = false;
            state.messageListSuccess = action.payload;
            state.messageListError = '';
        },
        setMessageListError: (state, action) => {
            state.messageListLoading = false;
            state.messageListSuccess = null;
            state.messageListError = action.payload;
        },
        getMessageReadLoading: (state, action) => {
            state.messageReadListLoading = true;
            state.messageReadListSuccess = null;
            state.messageReadListError = '';
        },
        getMessageReadSuccess: (state, action) => {
            state.messageReadListLoading = false;
            state.messageReadListSuccess = action.payload;
            state.messageReadListError = '';
        },
        getMessageReadError: (state, action) => {
            state.messageReadListLoading = false;
            state.messageReadListSuccess = null;
            state.messageReadListError = action.payload;
        },
        getMessageLoading: (state) => {
            state.getMessageDataLoading = true;
            state.getMessageDataSuccess = {};
            state.getMessageDataError = '';
        },
        getMessageSuccess: (state, action) => {
            state.getMessageDataLoading = false;
            state.getMessageDataSuccess = action.payload;
            state.getMessageDataError = '';
        },
        getMessageError: (state, action) => {
            state.getMessageDataLoading = false;
            state.getMessageDataSuccess = {};
            state.getMessageDataError = action.payload;
        },

        setVideoListLoading: (state, action) => {
            state.videoListLoading = true;
            state.videoListSuccess = null;
            state.videoListError = '';
        },
        setVideoListSuccess: (state, action) => {
            state.videoListLoading = false;
            state.videoListSuccess = action.payload;
            state.videoListError = '';
        },
        setVideoListError: (state, action) => {
            state.videoListLoading = false;
            state.videoListSuccess = null;
            state.videoListError = action.payload;
        },
        getVideoLoading: (state) => {
            state.getVideoDataLoading = true;
            state.getVideoDataSuccess = {};
            state.getVideoDataError = '';
        },
        getVideoSuccess: (state, action) => {
            state.getVideoDataLoading = false;
            state.getVideoDataSuccess = action.payload;
            state.getVideoDataError = '';
        },
        getVideoError: (state, action) => {
            state.getVideoDataLoading = false;
            state.getVideoDataSuccess = {};
            state.getVideoDataError = action.payload;
        },
        setYouTubeVideoListLoading: (state, action) => {
            state.youTubeVideoListLoading = true;
            state.youTubeVideoListSuccess = null;
            state.youTubeVideoListError = '';
        },
        setYouTubeVideoListSuccess: (state, action) => {
            state.youTubeVideoListLoading = false;
            state.youTubeVideoListSuccess = action.payload;
            state.youTubeVideoListError = '';
        },
        setYouTubeVideoListError: (state, action) => {
            state.youTubeVideoListLoading = false;
            state.youTubeVideoListSuccess = null;
            state.youTubeVideoListError = action.payload;
        },
        getYouTubeVideoLoading: (state) => {
            state.getYouTubeVideoDataLoading = true;
            state.getYouTubeVideoDataSuccess = {};
            state.getYouTubeVideoDataError = '';
        },
        getYouTubeVideoSuccess: (state, action) => {
            state.getYouTubeVideoDataLoading = false;
            state.getYouTubeVideoDataSuccess = action.payload;
            state.getYouTubeVideoDataError = '';
        },
        getYouTubeVideoError: (state, action) => {
            state.getYouTubeVideoDataLoading = false;
            state.getYouTubeVideoDataSuccess = {};
            state.getYouTubeVideoDataError = action.payload;
        },
        setCounsellingRegistrationsDataLoading: (state) => {
            state.getCounsellingListDataLoading = true;
            state.getCounsellingListDataSuccess = {};
            state.getCounsellingListDataError = '';
        },
        setCounsellingRegistrationsDataSuccess: (state, action) => {
            state.getCounsellingListDataLoading = false;
            state.getCounsellingListDataSuccess = action.payload;
            state.getCounsellingListDataError = '';
        },
        setCounsellingRegistrationsDataError: (state, action) => {
            state.getCounsellingListDataLoading = false;
            state.getCounsellingListDataSuccess = {};
            state.getCounsellingListDataError = action.payload;
        },
        setCounsellingSlotListLoading: (state) => {
            state.getCounsellingSlotListLoading = true;
            state.getCounsellingSlotListSuccess = {};
        },
        setCounsellingSlotListSuccess: (state, action) => {
            state.getCounsellingSlotListLoading = false;
            state.getCounsellingSlotListSuccess = action.payload;
        },
        setCounsellingSlotDataLoading: (state) => {
            state.getCounsellingSlotDataLoading = true;
            state.getCounsellingSlotDataSuccess = {};
        },
        setCounsellingSlotDataSuccess: (state, action) => {
            state.getCounsellingSlotDataLoading = false;
            state.getCounsellingSlotDataSuccess = action.payload;
        },
        resetMessageContent: (state, action) => {
            state.getMessageDataSuccess = {};
        },
        resetYouTubeContent: (state, action) => {
            state.getYouTubeVideoDataSuccess = {};
        },
        resetCounsellingContent: (state, action) => {
            state.getCounsellingSlotDataSuccess = {};
        },
    },
})

export const {
    setMessageGroupListLoading, setMessageGroupListSuccess, setMessageGroupListError,
    getMessageGroupLoading, getMessageGroupSuccess, getMessageGroupError,
    setMessageListLoading, setMessageListSuccess, setMessageListError,
    getMessageReadLoading, getMessageReadSuccess, getMessageReadError,
    getMessageLoading, getMessageSuccess, getMessageError,
    setVideoListLoading, setVideoListSuccess, setVideoListError,
    getVideoLoading, getVideoSuccess, getVideoError,
    resetMessageGroupDetails, resetMessageContent,
    setYouTubeVideoListLoading, setYouTubeVideoListSuccess, setYouTubeVideoListError,
    getYouTubeVideoLoading, getYouTubeVideoSuccess, getYouTubeVideoError, resetYouTubeContent,
    setCounsellingRegistrationsDataLoading,
    setCounsellingRegistrationsDataSuccess,
    setCounsellingRegistrationsDataError,
    setCounsellingSlotListLoading,
    setCounsellingSlotDataLoading,
    setCounsellingSlotDataSuccess,
    resetCounsellingContent,
    setCounsellingSlotListSuccess

} = messagesSlice.actions

export default messagesSlice.reducer;